"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : _type_of(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// index.ts
var index_exports = {};
__export(index_exports, {
    CookieCategoryBit: function() {
        return CookieCategoryBit;
    },
    DataConsentBit: function() {
        return DataConsentBit;
    },
    Xhr: function() {
        return Xhr;
    },
    checkCookieLimit: function() {
        return checkCookieLimit;
    },
    consentCategories: function() {
        return consentCategories;
    },
    contextCookies: function() {
        return contextCookies;
    },
    contextMarkersCookies: function() {
        return contextMarkersCookies;
    },
    cookiesLimits: function() {
        return cookiesLimits;
    },
    d: function() {
        return d;
    },
    extractDomain: function() {
        return extractDomain;
    },
    g: function() {
        return g;
    },
    internalMarkers: function() {
        return internalMarkers;
    },
    isExternalNavigation: function() {
        return isExternalNavigation;
    },
    makeCookiesPubl: function() {
        return makeCookiesPubl;
    },
    makeUserConsentVault: function() {
        return makeUserConsentVault;
    },
    n: function() {
        return n;
    },
    parseQuery: function() {
        return parseQuery;
    },
    removeQueryParams: function() {
        return removeQueryParams;
    },
    resolvePageUrl: function() {
        return resolvePageUrl;
    },
    resolveReferrer: function() {
        return resolveReferrer;
    },
    resolveUtmMarkers: function() {
        return resolveUtmMarkers;
    },
    utmCookies: function() {
        return utmCookies;
    },
    utmCookiesLimits: function() {
        return utmCookiesLimits;
    },
    utmMarkersCookies: function() {
        return utmMarkersCookies;
    },
    w: function() {
        return w;
    }
});
module.exports = __toCommonJS(index_exports);
// lib/resolvers/universal/pageUrl.ts
function resolvePageUrl(location) {
    return location.hostname + location.pathname;
}
// lib/resolvers/universal/referrer.ts
function resolveReferrer(param) {
    var referrer = param.referrer, locationHostname = param.locationHostname;
    var referrerHostname = "";
    if (referrer && referrer.hostname !== locationHostname) {
        referrerHostname = referrer.hostname;
    }
    return referrerHostname;
}
// lib/resolvers/universal/utmMarkers.ts
var import_empty = __toESM(require("@tinkoff/utils/is/empty"));
// lib/types/cookies.ts
var CookieCategoryBit = /* @__PURE__ */ function(CookieCategoryBit2) {
    CookieCategoryBit2[CookieCategoryBit2["Essential"] = 1] = "Essential";
    CookieCategoryBit2[CookieCategoryBit2["Functionality"] = 2] = "Functionality";
    CookieCategoryBit2[CookieCategoryBit2["Statistics"] = 4] = "Statistics";
    CookieCategoryBit2[CookieCategoryBit2["Marketing"] = 8] = "Marketing";
    return CookieCategoryBit2;
}(CookieCategoryBit || {});
var DataConsentBit = /* @__PURE__ */ function(DataConsentBit2) {
    DataConsentBit2[DataConsentBit2["PersonalDataProcessing"] = 16] = "PersonalDataProcessing";
    return DataConsentBit2;
}(DataConsentBit || {});
// lib/definitions/constants.ts
var positionPattern = /^\d+(0|s|t)\d+$/;
var internalMarkers = [
    "internal_source"
];
var SIXTY_DAYS = 60 * 24 * 60 * 60;
var STRING_DATA_LIMIT = 255;
var UserConsentAllowAll = 4503599627370495;
var consentCategories = {
    Essential: 1 /* Essential */ ,
    Functionality: 2 /* Functionality */ ,
    Statistics: 4 /* Statistics */ ,
    Marketing: 8 /* Marketing */ ,
    PersonalDataProcessing: 16 /* PersonalDataProcessing */ 
};
// lib/utils/advanced/is-external-navigation.ts
function isExternalNavigation(currentLocationHostname, referrerHostname) {
    var internalDomains = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (currentLocationHostname === referrerHostname) {
        return false;
    }
    return [
        currentLocationHostname,
        referrerHostname
    ].some(function(hostname) {
        return internalDomains.every(function(internalDomain) {
            return(// хост не является внутренним доменом и его саб-доменом
            hostname !== internalDomain && !hostname.endsWith(".".concat(internalDomain)));
        });
    });
}
// lib/utils/basic/string.ts
function isString(s) {
    return typeof s === "string";
}
// lib/utils/basic/pick.ts
function pick(names, obj) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            if (name in obj) {
                result[name] = obj[name];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
// lib/services/browser/storages/safe-storage.ts
var SafeStorage = /*#__PURE__*/ function() {
    function SafeStorage(storageType) {
        _class_call_check(this, SafeStorage);
        this.clear = this.getSafeVersionOfMethod("clear", void 0);
        this.key = this.getSafeVersionOfMethod("key", null);
        this.setItem = this.getSafeVersionOfMethod("setItem", void 0);
        this.getItem = this.getSafeVersionOfMethod("getItem", null);
        this.removeItem = this.getSafeVersionOfMethod("removeItem", void 0);
        this.storageType = storageType;
    }
    _create_class(SafeStorage, [
        {
            key: "length",
            get: function get() {
                try {
                    return this.storage.length;
                } catch (e) {}
                return 0;
            }
        },
        {
            key: "storage",
            get: function get() {
                if (!this.storageImpl) {
                    var storageImplsMap = {
                        local: localStorage,
                        session: sessionStorage
                    };
                    this.storageImpl = storageImplsMap[this.storageType];
                }
                return this.storageImpl;
            }
        },
        {
            key: "getSafeVersionOfMethod",
            value: function getSafeVersionOfMethod(method, defaultValue) {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    try {
                        var _this_storage;
                        return (_this_storage = _this.storage)[method].apply(_this_storage, _to_consumable_array(args));
                    } catch (e) {}
                    return defaultValue;
                };
            }
        }
    ]);
    return SafeStorage;
}();
var safeLocalStorage = new SafeStorage("local");
var safeSessionStorage = new SafeStorage("session");
// lib/utils/advanced/url.ts
function parseQuery(source) {
    var sepA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&", sepB = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    var result = {};
    var splitted = source.split(sepA);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = splitted[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var _String_split = _to_array(String(entry).split(sepB)), key = _String_split[0], parts = _String_split.slice(1);
            if (key) {
                var value = parts.join(sepB);
                try {
                    value = decodeURIComponent(value);
                } catch (e) {}
                result[decodeURIComponent(key)] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function removeQueryParams(href) {
    return href.split("?")[0];
}
// lib/definitions/cookieList.ts
var utmExpire = SIXTY_DAYS;
var utmCookiesCategory = 8 /* Marketing */  | 4 /* Statistics */ ;
var utmCookies = {
    utmSource: {
        name: "utm_source",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmContent: {
        name: "utm_content",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmCampaign: {
        name: "utm_campaign",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmMedium: {
        name: "utm_medium",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmTerm: {
        name: "utm_term",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmDateSet: {
        name: "utm_date_set",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    sid: {
        name: "sid",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    wm: {
        name: "wm",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    visitorNewOrReturn: {
        name: "s_nr",
        category: utmCookiesCategory,
        expires: 365 * 24 * 60 * 60,
        // 365 days in seconds
        subdomains: true
    }
};
var contextCookies = {
    ctxSource: {
        name: "ctx_source",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    ctxPosition: {
        name: "ctx_position",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    ctxBlock: {
        name: "ctx_block",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    }
};
// lib/utils/advanced/truncate.ts
var import_toPairs = __toESM(require("@tinkoff/utils/object/toPairs"));
var import_fromPairs = __toESM(require("@tinkoff/utils/object/fromPairs"));
function truncateValuesAndMark(cookiesLimits2, values) {
    var entries = (0, import_toPairs.default)(values).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (typeof value !== "string") {
            return [
                key,
                value
            ];
        }
        var limit = key in cookiesLimits2 ? cookiesLimits2[key] : cookiesLimits2.default;
        return [
            key,
            truncateAndMark(value, limit)
        ];
    });
    return (0, import_fromPairs.default)(entries);
}
function truncateAndMark(originalValue, encodedLimit) {
    var cutValue = originalValue;
    var CUT_POSTFIX = ".cut";
    if (cutValue.length > STRING_DATA_LIMIT) {
        var limit = STRING_DATA_LIMIT - CUT_POSTFIX.length;
        cutValue = truncateDecoded(cutValue, limit);
    }
    if (encodeURIComponent(cutValue).length > encodedLimit) {
        var limit1 = encodedLimit - CUT_POSTFIX.length;
        cutValue = truncateEncoded(cutValue, limit1);
    }
    if (cutValue === originalValue) {
        return originalValue;
    }
    return "".concat(cutValue).concat(CUT_POSTFIX);
}
function truncateDecoded(value, limit) {
    return value.slice(0, limit);
}
function truncateEncoded(value, limit) {
    var indexInLimit = 0;
    var indexOverLimit = value.length + 1;
    while(indexInLimit + 1 < indexOverLimit){
        var mid = Math.floor((indexInLimit + indexOverLimit) / 2);
        var encoded = encodeURIComponent(value.slice(0, mid));
        if (encoded.length > limit) {
            indexOverLimit = mid;
        } else {
            indexInLimit = mid;
        }
    }
    return value.slice(0, indexInLimit);
}
// lib/definitions/cookies-limits.ts
var UTM_SOURCE_LIMIT = 255;
var _obj;
var utmCookiesLimits = (_obj = {}, // group="platform_nginx" upstream_name:"*.pfp-prod.v2.prod.k8s.tcsbank.ru"  status:200 request_method:"GET"  | rex  field=query_string r"(utm_term\=(?<utm_field>[^&]+))"  | where utm_field != null | eval utm_len=len(utm_field) | top limit=25 utm_len
// синхронизируй в utmMarkers.md!
_define_property(_obj, utmCookies.utmSource.name, UTM_SOURCE_LIMIT), _define_property(_obj, "session_utm_source", UTM_SOURCE_LIMIT), _define_property(_obj, utmCookies.utmTerm.name, 600), _define_property(_obj, utmCookies.utmContent.name, 600), _define_property(_obj, utmCookies.utmCampaign.name, 255), _define_property(_obj, utmCookies.utmMedium.name, 255), _define_property(_obj, utmCookies.sid.name, 140), _define_property(_obj, utmCookies.wm.name, 100), _obj);
var cookiesLimits = _object_spread_props(_object_spread({}, utmCookiesLimits), {
    default: 72
});
// lib/resolvers/universal/utmMarkers.ts
var SESSION_SOURCE_STORAGE_ITEM = "session_utm_source";
var utmMarkersCookies = [
    utmCookies.utmSource,
    utmCookies.utmContent,
    utmCookies.utmCampaign,
    utmCookies.utmMedium,
    utmCookies.utmTerm,
    utmCookies.sid,
    utmCookies.wm
];
var contextMarkersCookies = [
    contextCookies.ctxPosition,
    contextCookies.ctxBlock,
    contextCookies.ctxSource
];
function resolveUtmMarkers(param) {
    var cookies = param.cookies, location = param.location, referrer = param.referrer, parseUrl = param.parseUrl, internalDomains = param.internalDomains;
    var utmMarkersNameList = utmMarkersCookies.map(function(c) {
        return c.name;
    });
    var contextMarkersNameList = contextMarkersCookies.map(function(c) {
        return c.name;
    });
    var parentUrl = location.query.parent_url;
    var parentLocation = parentUrl ? parseUrl(parentUrl) : void 0;
    var query = location.query.utm_source || !parentLocation ? location.query : parentLocation.query;
    var hash = location.hash.replace("#", "");
    var hashParsed = hash ? parseQuery(hash) : {};
    var internalQuery = pick(internalMarkers, query);
    var utmFromQuery = pick(utmMarkersNameList, query);
    var utmFromHash = pick(utmMarkersNameList, hashParsed);
    var utmQuery = (0, import_empty.default)(utmFromQuery) ? utmFromHash : utmFromQuery;
    function setOrRemove(ownCookies, values) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ownCookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cookie = _step.value;
                var value = values[cookie.name];
                if (value) {
                    cookies.set(cookie, value);
                } else {
                    cookies.remove(cookie.name, true);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function pickCookies(names) {
        return pick(names, cookies.getAll());
    }
    function collectInternalParamsFromQuery() {
        return _object_spread({
            internal_source: ""
        }, internalQuery);
    }
    function collectMarkersFromQuery() {
        return _object_spread({
            collectionMethod: "get",
            cookieDate: Date.now(),
            utm_source: "",
            session_utm_source: utmQuery.utm_source || ""
        }, collectInternalParamsFromQuery(), utmQuery);
    }
    function colletMarkersFromStorage() {
        var utmCookiesData = pickCookies(utmMarkersNameList);
        var cookieDate = Number(cookies.get("utm_date_set")) || null;
        var sessionUtmSource = safeSessionStorage.getItem(SESSION_SOURCE_STORAGE_ITEM) || "";
        var collectionMethod = null;
        if (utmCookiesData.utm_source) {
            collectionMethod = "cookie";
        }
        return _object_spread({
            collectionMethod: collectionMethod,
            cookieDate: cookieDate,
            utm_source: "",
            session_utm_source: sessionUtmSource
        }, collectInternalParamsFromQuery(), utmCookiesData);
    }
    function collectMarkersFromReferrer(referrerValue) {
        return _object_spread({
            utm_source: referrerValue,
            session_utm_source: referrerValue,
            collectionMethod: "referrer",
            cookieDate: Date.now()
        }, collectInternalParamsFromQuery());
    }
    function collectContextParamsFromQuery() {
        var position = query["position" /* position */ ];
        if (!isString(position)) {
            return {};
        }
        var isGoogle = positionPattern.test(position);
        var contextParams2 = {};
        var positionSplitted;
        if (isGoogle) {
            positionSplitted = position.split(/\D/);
            contextParams2.ctx_position = positionSplitted.length > 1 ? positionSplitted[1] : "";
            contextParams2.ctx_block = positionSplitted[0] + position.replace(/\d/g, "");
        } else {
            contextParams2.ctx_position = position;
            contextParams2.ctx_block = query["block" /* block */ ];
        }
        contextParams2.ctx_source = query["source" /* source */ ] || "";
        return contextParams2;
    }
    function storeMarkers(utmMarkers2, contextParams2) {
        var onlySession2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!onlySession2) {
            cookies.set(utmCookies.utmDateSet, utmMarkers2.cookieDate || Date.now());
            setOrRemove(utmMarkersCookies, utmMarkers2);
            setOrRemove(contextMarkersCookies, contextParams2 || {});
        }
        if (utmMarkers2.session_utm_source) {
            safeSessionStorage.setItem(SESSION_SOURCE_STORAGE_ITEM, utmMarkers2.session_utm_source);
        }
    }
    var utmMarkers;
    var contextParams;
    var shouldStore = false;
    var onlySession = false;
    (function() {
        var _utmMarkers_utm_source;
        if (utmQuery.utm_source) {
            utmMarkers = collectMarkersFromQuery();
            contextParams = collectContextParamsFromQuery();
            shouldStore = true;
            return;
        }
        utmMarkers = colletMarkersFromStorage();
        if (!referrer || !isExternalNavigation(location.hostname, referrer, internalDomains)) {
            return;
        }
        var isFreeSource = (_utmMarkers_utm_source = utmMarkers.utm_source) === null || _utmMarkers_utm_source === void 0 ? void 0 : _utmMarkers_utm_source.includes(".");
        if (!utmMarkers.utm_source || isFreeSource) {
            utmMarkers = collectMarkersFromReferrer(referrer);
            contextParams = {};
            shouldStore = true;
            return;
        }
        if (!utmMarkers.session_utm_source) {
            utmMarkers.session_utm_source = referrer;
            shouldStore = true;
            onlySession = true;
        }
    })();
    utmMarkers = truncateValuesAndMark(cookiesLimits, utmMarkers);
    contextParams = truncateValuesAndMark(cookiesLimits, contextParams !== null && contextParams !== void 0 ? contextParams : {});
    if (shouldStore) {
        storeMarkers(utmMarkers, contextParams, onlySession);
    }
    if (contextParams) {
        contextParams = pickCookies(contextMarkersNameList);
    }
    return _object_spread_props(_object_spread({}, contextParams), {
        utmMarkers: utmMarkers
    });
}
// lib/definitions/global.ts
var g = function() {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
}();
var d = g.document;
var w = g.window;
var n = g.navigator;
var Xhr = g.XMLHttpRequest;
// lib/services/shared/cookies/checkCookieLimit.ts
function checkCookieLimit(limits, name, rawValue) {
    var value = encodeURIComponent(rawValue);
    var limit = limits[name] || limits.default;
    if (value.length > limit) {
        throw new Error("ECookieTooLarge: cookie ".concat(name, " exceeds maximum length of ").concat(limit, " bytes"));
    }
}
// lib/services/shared/cookies/public.ts
function makeCookiesPubl(cookiesImpl, consentVault) {
    var awaitingValues = {};
    var setCookie = function(cookie, value) {
        cookiesImpl.set(cookie.name, value, cookie.expires, cookie.subdomains);
    };
    consentVault.on("update", function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(awaitingValues)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var _awaitingValues_key = awaitingValues[key], cookie = _awaitingValues_key.cookie, value = _awaitingValues_key.value;
                if (consentVault.isAllowed(cookie.category)) {
                    setCookie(cookie, value);
                    delete awaitingValues[key];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return {
        get: function get(name) {
            return cookiesImpl.get(name);
        },
        getAll: function getAll() {
            return cookiesImpl.getAll();
        },
        set: function set(cookie, value) {
            var isAllowed = consentVault.isAllowed(cookie.category);
            if (isAllowed) {
                setCookie(cookie, value);
            } else {
                awaitingValues[cookie.name] = {
                    cookie: cookie,
                    value: value
                };
            }
            return isAllowed;
        },
        remove: function remove(name, subdomains) {
            delete awaitingValues[name];
            cookiesImpl.remove(name, subdomains);
        }
    };
}
// lib/services/shared/consentVault.ts
var import_emitt = __toESM(require("emitt"));
function makeUserConsentVault() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _opts_defaults = opts.defaults, defaults = _opts_defaults === void 0 ? UserConsentAllowAll : _opts_defaults, _opts_alwaysEnabled = opts.alwaysEnabled, alwaysEnabled = _opts_alwaysEnabled === void 0 ? 1 /* Essential */  : _opts_alwaysEnabled;
    var allowedMask = defaults;
    var vault = (0, import_emitt.default)();
    return Object.assign(vault, {
        once: function once(event, fn) {
            var handler = function() {
                vault.off(event, handler);
                fn();
            };
            vault.on(event, handler);
        },
        isAllowed: function isAllowed(mask) {
            return (this.getAllowedMask() & mask) === mask;
        },
        resetAllTo: function resetAllTo(mask) {
            allowedMask = mask;
            vault.emit("update");
        },
        update: function update(cats) {
            var untouchedPolicy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keep";
            if (untouchedPolicy === "enable") {
                allowedMask |= UserConsentAllowAll;
            } else if (untouchedPolicy === "disable") {
                allowedMask = 0;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(cats)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var category = Number(key);
                    if (cats[category]) {
                        allowedMask |= category;
                    } else {
                        allowedMask &= ~category;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            vault.emit("update");
        },
        getAllowedMask: function getAllowedMask() {
            return (allowedMask !== null && allowedMask !== void 0 ? allowedMask : defaults) | alwaysEnabled;
        },
        categories: consentCategories
    });
}
// lib/utils/advanced/domain.ts
var reIpWithDots = /^(?:::(?:ffff:(0:)?)?)?(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
var reIpv4Embedded = /^([0-9a-fA-F]{1,4}:){1,4}:(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
function isIpWithDots(host) {
    return reIpWithDots.test(host) || reIpv4Embedded.test(host);
}
function extractDomain(hostname) {
    if (isIpWithDots(hostname)) {
        return hostname;
    }
    return hostname.indexOf("localhost") >= 0 ? "localhost" : ".".concat(hostname.split(".").slice(-2).join("."));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    CookieCategoryBit: CookieCategoryBit,
    DataConsentBit: DataConsentBit,
    Xhr: Xhr,
    checkCookieLimit: checkCookieLimit,
    consentCategories: consentCategories,
    contextCookies: contextCookies,
    contextMarkersCookies: contextMarkersCookies,
    cookiesLimits: cookiesLimits,
    d: d,
    extractDomain: extractDomain,
    g: g,
    internalMarkers: internalMarkers,
    isExternalNavigation: isExternalNavigation,
    makeCookiesPubl: makeCookiesPubl,
    makeUserConsentVault: makeUserConsentVault,
    n: n,
    parseQuery: parseQuery,
    removeQueryParams: removeQueryParams,
    resolvePageUrl: resolvePageUrl,
    resolveReferrer: resolveReferrer,
    resolveUtmMarkers: resolveUtmMarkers,
    utmCookies: utmCookies,
    utmCookiesLimits: utmCookiesLimits,
    utmMarkersCookies: utmMarkersCookies,
    w: w
});
//# sourceMappingURL=index.js.map